export default __webpack_public_path__ + "static/media/cert-cpttm.1bcd4ae3.jpg";